import { Injectable } from '@angular/core';
import { DynamicLinkService } from './dynamic-link.service';

@Injectable({
  providedIn: 'root',
})
export class HandleInnerHtmlService {
  constructor(private dynamicLinkService: DynamicLinkService) {}

  handleKycLink(value: string): string {
    if (!value) return value;
    return value.replace(/\/userCentre\/kyc/g, `<span class="userCenter-kyc text-primary">KYC page</span>`);
  }

  handleSpecialChar(value: string): string {
    return this.dynamicLinkService.replaceDomainPlaceholder(value);
  }
}
